/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { colors } from '../../styles/colors'
import Item from './components/Item'
import { StyledTab } from './styles'

interface ITabsItemProps {
  href?: string
  color?: string
  placement?: string
  disabled?: boolean
  active: boolean
  onClick?(e: any): void
}

interface ITabsProps {
  color?: string
  background?: string
  disabled?: boolean
  showDivider?: boolean
}

type TItemComponent = React.FunctionComponent<ITabsItemProps>
type TTabsComponent = React.FunctionComponent<ITabsProps> & {
  Item: TItemComponent
}

const Tabs: TTabsComponent = ({
  color = 'blue',
  background = colors.blue,
  disabled,
  ...props
}) => {
  const renderChildren = () => {
    return React.Children.map(props.children, (item: any, index) =>
      React.cloneElement(item, {
        color,
        disabled,
        key: index,
      }),
    )
  }

  return (
    <StyledTab background={background} color={color} {...props}>
      {renderChildren()}
    </StyledTab>
  )
}

Tabs.Item = Item

export default Tabs
